import React from 'react';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

export default function CurrencyField({ label, helperText, style }) {
    const [variable, setVariable] = React.useState(0);

    return (
        <CurrencyTextField
            variant="standard"
            value={variable}
            currencySymbol="£"
            outputFormat="number"
            onChange={(event, value) => setVariable(value)}
            label={label}
            helperText={helperText}
            style={{...style}}
        />
    )
}
